<template>
    <Teleport v-if="parentDom" :to="parentDom">
        <div
            ref="markerRef"
            class="marker-icon map-marker"
            :class="[
                { active: data.showAddress ? true : active === fmLatlng },
                data.type
            ]"
            @mouseenter="onMouseEnter"
            @mouseleave="onMouseLeave"
            @click="onClick"
            v-bind="$attrs"
        >
            <i 
                v-if="useIconAddress"
                class="iconfont icon-address"
            ></i>
            <i  
                v-else
                :class="['iconfont', data.icon, data.markerStyle]"
                :style="data.style"
            >
                <span v-if="count > 1" class="count">{{ count }}</span>
            </i>
            <div
                ref="pop"
                class="marker-pop"
                :class="{ bottom: popBottom }"
                :style="popStyle"
                v-if="names.length"
            >
                <span
                    ref="popinter"
                    class="pointer"
                    :style="pointerStyle"
                ></span>
                <p v-for="(name, index) in names" :key="index">{{ name }}</p>
                <p v-if="count > 5">...</p>
            </div>
        </div>
    </Teleport>
</template>
<script>
import Marker from './marker';
export default {
    mixins: [Marker],
    data: function() {
        return {
            type: 'icon'
        };
    },
    props: {
        useIconAddress: {
            type: Boolean,
            default: false
        },
    },
    computed: {
        count() {
            return this.data.names.length;
        },
        names() {
            return this.data.names.filter(Boolean).slice(0, 5);
        }
    }
};
</script>
